define.alias("checkout/components/add-ons", "settings/components/add-ons");